import { render } from "./OrgTree.vue?vue&type=template&id=b59cebaa&scoped=true"
import script from "./OrgTree.vue?vue&type=script&lang=js"
export * from "./OrgTree.vue?vue&type=script&lang=js"

import "./OrgTree.vue?vue&type=style&index=0&id=b59cebaa&scoped=true&lang=css"

import exportComponent from "/Users/hank/winho/gx/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b59cebaa"]])

export default __exports__